import { ReactNode, createContext, useContext, useState } from "react";
import DeactivateModal from "./DeactivateModal";
import { ISos } from "models/sos";

interface IAlertProps {
  showDeactivate: (sos: ISos) => void;
}

export const AlertContext = createContext<IAlertProps>({} as IAlertProps);

export const useAlertContext = () => useContext<IAlertProps>(AlertContext);

interface IOpen {
  open: boolean;
  sos: ISos | null;
}

export function AlertContextProvider({ children }: { children: ReactNode }) {
  const [openDeactivate, setOpenDeactivate] = useState<IOpen>({
    open: false,
    sos: null,
  });

  const showDeactivate = (sos: ISos) => setOpenDeactivate({ open: true, sos });

  const handleCloseDeactivate = () =>
    setOpenDeactivate({ open: false, sos: null });

  return (
    <AlertContext.Provider
      value={{
        showDeactivate,
      }}
    >
      {openDeactivate.sos && (
        <DeactivateModal
          open={openDeactivate.open}
          sos={openDeactivate.sos}
          handleClose={handleCloseDeactivate}
        />
      )}
      {children}
    </AlertContext.Provider>
  );
}
